module.exports = __webpack_public_path__ + "assets/img/2786f957c1df3ab2424169e71a8ccc4f.png";